











































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { pagination, loadingCatch, loading } from "@root/lib/decorator";

const Root = namespace("root");

@Component({
  // filters: {
  //   replaceStart0: (value: string) => {
  //     let val = (Number(value) + 1).toString();
  //     return `${val.replace(/\b(0+)/gi, "")}`;
  //   },
  //   $index: (value: number) => {
  //     value = value + 1;
  //     return value;
  //   }
  // }
})
@pagination("queryImportDetail", {
  pageSize: 5
})
@loading()
export default class ImportDialog extends Vue {
  @Prop({ required: true }) detailData: any;

  @Root.Action queryImportFileDetail;

  private dialogTableVisible = false;
  private dataList = [];
  private detailsData = null;
  private resultInfo = null;

  @Watch("detailData")
  onDetailDataChange(val) {
    if (val) {
      this.detailsData = { ...val };
      this.resultInfo = {
        errorCount: val.errorCount || 0,
        successCount: val.successCount || 0,
        totalCount: val.totalCount || 0,
        createTime: val.createTime || "",
        name: val.name || ""
      };
      this.queryImportDetail();
    }
  }

  async queryImportDetail() {
    const { pageSize, pageNum, detailsData } = this as any;
    const { importNo } = detailsData;

    let fetchData = {
      pageInput: {
        pageSize,
        pageNum
      },
      condition: {
        importNo,
        status: "FAILED"
      }
    };

    let { dataList, total } = await this.queryImportFileDetail(fetchData);

    (this as any).total = total;
    this.dataList = dataList;
  }
}
